import { Row, Col, Collapse } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import "./HomePage.css";
import { useLang } from "../LangContext";
import { useTheme } from "../ThemeContext";
import { QuestionBlock, QuestionCard } from "./QuestionsModule";
import styles from "./ReferralPage.module.css";

function QuestionsModule() {
  const [openedCard, setOpenedCard] = useState(null);
  const { lang, changeLang, t } = useLang();

  const cards = [
    {
      header: t("qHeader1"),
      isOpened: true,
      description: t("qDescr1"),
      key: 0,
    },
    {
      header: t("qHeader2"),
      isOpened: true,
      description: t("qDescr2"),
      key: 1,
    },
    {
      header: t("qHeader3"),
      isOpened: true,
      description: t("qDescr3"),
      key: 2,
    },
    {
      header: t("qHeader4"),
      isOpened: true,
      description: t("qDescr4"),
      key: 3,
    },
  ];
  return (
    <Row className="mt-2  gx-3 gy-3">
      <Col xs={12} md={12} lg={6}>
        <Row xs={1} className="gy-2">
          {cards.map((el) => (
            <Col>
              <QuestionCard
                {...el}
                isOpened={el.key === openedCard}
                setOpened={setOpenedCard}
                index={el.key}
                key={el.key}
              />
            </Col>
          ))}
        </Row>
      </Col>
      <Col xs={12} md={6} lg={3}>
        <QuestionBlock
          header={t("qCardHeader1")}
          description={t("qCardDescr1")}
          linkText={t("qCardLink1")}
          link={"https://wiki.qwins.co/"}
        />
      </Col>
      <Col xs={12} md={6} lg={3}>
        <QuestionBlock
          header={t("qCardHeader2")}
          description={t("qCardDescr2")}
          linkText={t("qCardLink2")}
          link={"https://t.me/qwinshelp"}
        />
      </Col>
    </Row>
  );
}

function MinorBanner({ isLg, isXl }) {
  const { lang, changeLang, t } = useLang();

  const { s, toggleTheme } = useTheme();
  return (
    <div
      className={`${styles.minorBanner} mt-4`}
      style={s.RPMainBanner}
      // style={s.DCProsCard}
    >
      {isXl && (
        <>
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="551"
            height="174"
            viewBox="0 0 551 174"
            fill="none"
            className={styles.minorBannerLeft}
          >
            {s.DCMinorLeft}
          </svg> */}
          <svg
            width="360"
            height="274"
            viewBox="0 0 360 274"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.minorBannerLeft}
          >
            {s.RPMainBannerLeft}
          </svg>

          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="487"
            height="180"
            viewBox="0 0 487 180"
            fill="none"
            className={styles.minorBannerRight}
          >
            {s.DCMinorRight}
          </svg> */}
          <svg
            width="359"
            height="286"
            viewBox="0 0 359 286"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.minorBannerRight}
          >
            {s.RPMainBannerRight}
          </svg>
        </>
      )}
      <h4 style={{ color: s.DCProsHeader }}>{t("RPMainBannerHeader")}</h4>
      <p
        className="mt-3"
        style={{ color: s.RPTextColor }}
        //   style={{ color: s.DCProsText }}
      >
        {t("RPMainBannerText1")}
        {(isLg || isXl) && <br />}
        {t("RPMainBannerText2")}
      </p>
      <a href="https://my.qwins.co/">
        <button
          className={`mt-3 ${styles.minorBtn}`}
          style={{
            color: s.guideCard2Bg,
            ...s.VSMainBannerBtnHover,
          }}
        >
          <span className={styles.btnText}>{t("RPMainBannerBtn")}</span>
        </button>
      </a>
    </div>
  );
}

function ProsBigCard({ header, description, style, gifPartTemplate }) {
  const { s, toggleTheme } = useTheme();

  const divClass = `${styles.card}`;
  const headingPart = (
    <Col xs={12}>
      <h4 style={{ ...s.cardHeader, fontFamily: "Gilroy-semibold" }}>
        {header}
      </h4>
      <p
        //   style={s.cardDescr}
        className={styles.cardDescr}
        style={{ color: s.RPTextColor }}
      >
        {description}
      </p>
    </Col>
  );
  const gifPart = (
    <Col xs={12}>
      <div className="w-100 d-flex justify-content-center align-items-center">
        {gifPartTemplate}
      </div>
    </Col>
  );
  return (
    <Col>
      <div
        className={`${divClass} h-100`}
        style={{
          ...s.cardBg,
          padding: style !== 1 ? "51px 32px 15px 32px" : "23px 32px 40px 32px",
        }}
      >
        <Row className="g-0">
          {style === 1 ? (
            <>
              {headingPart}
              <div className="mt-3"></div>
              {gifPart}
            </>
          ) : (
            <>
              {gifPart}
              <div className="mt-3 mt-sm-5"></div>
              {headingPart}
            </>
          )}
        </Row>
      </div>
    </Col>
  );
}

function ProsModule({ isXs, isSm }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();

  return (
    <Row xs={1} lg={2} className="gx-5 gy-3 mt-1 mt-lg-4 align-items-stretch">
      <ProsBigCard
        header={t("RPProsHeader1")}
        description={t("RPProsText1")}
        gifPartTemplate={
          <svg
            width="565"
            height="106"
            viewBox="0 0 565 106"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {s.RPProsPic}
          </svg>
        }
        style={2}
      />
      <ProsBigCard
        header={t("RPProsHeader2")}
        description={t("RPProsText2")}
        gifPartTemplate={
          <div className="w-100">
            <div className="w-100 d-flex justify-content-start">
              {/* {s.RPNotifLeft} */}
              <div className={styles.notifBlock} style={s.RPNotifBlock}>
                <svg
                  width={isXs ? "30" : "40"}
                  height={isXs ? "30" : "40"}
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {s.RPNotifIcon}
                </svg>
                <div className={styles.notifText}>
                  <h6 style={{ color: s.RPBlockHeaderColor }}>
                    {t("RPNotifHeader")}
                  </h6>
                  <p style={{ color: s.RPNotifText }}>{t("RPNotifText")}</p>
                </div>
                <h5
                  className={styles.notifMoney}
                  style={{ color: s.navIconsColor }}
                >
                  +30$
                </h5>
              </div>
            </div>
            <div className="w-100 d-flex justify-content-end mt-1 mt-sm-3">
              <div className={styles.notifBlock} style={s.RPNotifBlock}>
                <svg
                  width={isXs ? "30" : "40"}
                  height={isXs ? "30" : "40"}
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {s.RPNotifIcon}
                </svg>
                <div className={styles.notifText}>
                  <h6 style={{ color: s.RPBlockHeaderColor }}>
                    {t("RPNotifHeader")}
                  </h6>
                  <p style={{ color: s.RPNotifText }}>{t("RPNotifText")} </p>
                </div>
                <h5
                  className={styles.notifMoney}
                  style={{ color: s.navIconsColor }}
                >
                  +50$
                </h5>
              </div>
            </div>
          </div>
        }
        style={1}
      />
    </Row>
  );
}

function InfoBlock({ text }) {
  const { s, toggleTheme } = useTheme();

  return (
    <div
      className={`${styles.infoBlock} mt-3`}
      style={{ ...s.RMainBanner, color: s.RPBlockHeaderColor }}
    >
      {text}
    </div>
  );
}

function InfoModule() {
  const { lang, changeLang, t } = useLang();

  const infoBlocks = [
    t("RPTextBlock1"),
    t("RPTextBlock2"),
    t("RPTextBlock3"),
    t("RPTextBlock4"),
  ];
  return (
    <div className="mt-lg-5">
      {infoBlocks.map((el, index) => (
        <InfoBlock text={el} key={index} />
      ))}
    </div>
  );
}

export default function ReferralPage({ windowSize, setCurPage }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();

  return (
    <>
      <MinorBanner isLg={windowSize.isLg} isXl={windowSize.isXl} />
      <ProsModule isXs={windowSize.isXs} isSm={windowSize.isSm} />
      <InfoModule />
      {/* <div style={{ textAlign: "left" }}>
        <h4
          className={`${styles.minorHeader} mt-5 mb-0`}
          style={{ ...s.minorHeader, fontFamily: "Gilroy-semibold" }}
        >
          {t("qMinorHeader")}
        </h4>
      </div>

      <QuestionsModule /> */}
    </>
  );
}
